// extracted by mini-css-extract-plugin
module.exports = {"navigation":"HomeLayout-module--navigation--zM7Iv","widgets":"HomeLayout-module--widgets--2Eokt","content":"HomeLayout-module--content--CPlAV"};